import { NotificationType } from "../components/admin/notification-admin/add-notification.component";

export class HhsgSharedNotificationModel {
    id: number;
    name: string;
    message: string;
    clientId: number; // Client Id, Client Name
    applicationId: number;
    createdDate: Date;
    UserId: number;
    notificationType: NotificationType;
    isHighPriority: boolean;
    emailUserIds: string[];
}